import React from "react";
import { Link } from "react-router-dom";
import { Hammer, Wrench, Trees, Building2 } from "lucide-react";

function Pillar({ Icon, title, description, ctaLabel, to }) {
  return (
    <div className="bg-white p-6 rounded border border-gray-200">
      <Icon className="text-br-bronze" />
      <h3 className="font-display tracking-widest uppercase mt-2 text-sm">{title}</h3>
      <p className="text-sm text-gray-700 mt-2 leading-relaxed">{description}</p>
      <Link to={to} className="mt-3 inline-block text-xs uppercase font-bold tracking-widest text-br-bronze hover:underline">{ctaLabel} →</Link>
    </div>
  );
}

export default function CityServicePillars({ cityName }) {
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <Pillar
        Icon={Hammer}
        title={`Construction & Remodeling in ${cityName}`}
        description="Kitchens, bathrooms, full-home remodels, home additions, ADUs, garage conversions, and finish work — coordinated under one general contractor."
        ctaLabel="All Construction Services"
        to="/construction-services"
      />
      <Pillar
        Icon={Building2}
        title={`Roofing in ${cityName}`}
        description={`Roof inspections, repair, replacement, and storm follow-up for ${cityName} homes. We document honestly and don't promise insurance outcomes.`}
        ctaLabel="Roofing Details"
        to="/roofing"
      />
      <Pillar
        Icon={Wrench}
        title={`Maintenance Plans in ${cityName}`}
        description={`Monthly memberships keep a trusted contractor familiar with your ${cityName} home. Defined covered work, priority scheduling, member pricing.`}
        ctaLabel="View Maintenance Plans"
        to="/maintenance-plans"
      />
      <Pillar
        Icon={Trees}
        title={`Popular Projects for ${cityName} Homeowners`}
        description="Covered patios, pergolas, decks, outdoor kitchens, ADUs, kitchen and bath upgrades, and exterior durability improvements."
        ctaLabel="Popular Austin Services"
        to="/popular-austin-services"
      />
    </div>
  );
}
